import React, { useEffect, useState } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";

const PrivateRoute = () => {
  const [login] = useState(JSON.parse(localStorage.getItem("login")));
  const [authenticated, setAuthenticated] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setAuthenticated(JSON.parse(localStorage.getItem("authenticated")));
  }, []);

  // Check if user is authenticated
  if (!login && !authenticated) {
    // Get current path
    const currentPath = location.pathname + location.search;

    // Check if user is trying to access a meeting
    if (currentPath.includes("/mursal-meetings/")) {
      const meetingId = currentPath.split("/mursal-meetings/")[1];
      // Redirect to login with meeting ID in URL
      return <Navigate to={`${process.env.PUBLIC_URL}/login/${meetingId}`} />;
    }

    // Regular redirect to login
    return <Navigate to={`${process.env.PUBLIC_URL}/login`} />;
  }

  return <Outlet />;
};

export default PrivateRoute;
